import {
    Container,
    MainContentWrapper,
    MainContent,
    Heading,
} from '../../../styles/account/account'
import { DashboardWrapper } from '../../../container/dashboardWrapper'
import { Breadcrumb } from '../../../components/breadcrumb/breadcrumb'
import { Button } from '../../../components/button'
import { Link } from 'react-router-dom';
import { ModuleHeader } from '../../../components/module-header'
import { Announcements as AnnouncementFeed } from "../../../components/dashboard-announcements";
import { UploadButtonContainer } from '../../../styles/library';
const Announcements = () => {
    return (
        <DashboardWrapper>
            <MainContentWrapper fullHeight>
                <Container>
                    <MainContent>
                        <UploadButtonContainer>
                            <Link to="/teacher/announcements/create">
                                <Button variant="secondary">MAKE ANNOUNCEMENT</Button>
                            </Link>
                        </UploadButtonContainer>
                        <Heading>
                            Announcements
                        </Heading>
                        <Breadcrumb
                            crumbs={['Announcements']}
                        />
                        <ModuleHeader title="ANNOUNCEMENT FEED" />
                        <AnnouncementFeed search />
                    </MainContent>
                </Container>
            </MainContentWrapper>
        </DashboardWrapper>
    )
}

export default Announcements
